<template>
    <div>
        <b-row>
            <b-col cols="12" sm="6" md="6" lg="4">
                <div class="card card-stats">
                    <div class="card-header card-header-warning card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">analytics</i>
                        </div>
                        <p class="card-category">Bestellung</p>
                        <h3 class="card-title">
                            <small>{{report.allOrders}}</small>
                        </h3>
                    </div>
                    <div class="card-footer">
                        <div class="stats">
                            <a href="javascript:;">All time</a>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="4">
                <div class="card card-stats">
                    <div class="card-header card-header-warning card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">analytics</i>
                        </div>
                        <p class="card-category">Bestellung</p>
                        <h3 class="card-title">
                            <small>{{report.ordersWeek}}</small>
                        </h3>
                    </div>
                    <div class="card-footer">
                        <div class="stats">
                            <a href="javascript:;">week</a>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="4">
                <div class="card card-stats">
                    <div class="card-header card-header-warning card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">analytics</i>
                        </div>
                        <p class="card-category">Bestellung</p>
                        <h3 class="card-title">
                            <small>{{report.ordersMonth}}</small>
                        </h3>
                    </div>
                    <div class="card-footer">
                        <div class="stats">
                            <a href="javascript:;">Monthly</a>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "reports",
        props: {
            report: {
                type: Object,
                default: null
            }
        }
    }
</script>

<style scoped>

</style>